import script from "./czy_bk.vue?vue&type=script&setup=true&lang=js"
export * from "./czy_bk.vue?vue&type=script&setup=true&lang=js"

import "./czy_bk.vue?vue&type=style&index=0&id=12fd9b6e&lang=less"

const __exports__ = script;

export default __exports__